import { PUBLIC_CHAT_ID } from './chat-conversation.service';
import { PinnedMeetingProviderService } from './pinned-meeting-provider.service';

export class InitialMeetingProviderService {
    static $inject = ['PinnedMeetingProviderService'];

    constructor(private pinnedMeetingProviderService: PinnedMeetingProviderService) {}

    public async getInitialMeetingId(): Promise<number | null> {
        const pinned = await this.pinnedMeetingProviderService.getPinnedMeetingId();
        // if there is no pinned meeting - return PUBLIC_CHAT_ID
        return pinned || this.getFallbackMeetingId();
    }

    public getFallbackMeetingId() {
        return PUBLIC_CHAT_ID;
    }
}

angular.module('tradersyard').service('InitialMeetingProviderService', InitialMeetingProviderService);
